import { useSelector } from "react-redux";
import { useGetAssignmentMarksQuery } from "../../../features/assignmentMark/assignmentMarkApi";
import { useGetStudentsQuery } from "../../../features/users/usersApi";
import { useGetQuizMarksQuery } from "../../../features/quizMark/quizMarkApi";
import MyPosition from "./MyPosition";
import Top20Position from "./Top20Position";
import EmptyResult from "../../ui/EmptyResult";
import Loading from "../../ui/Loading";
import Error from "../../ui/Error";

export default function Leaderboard() {
	const loggedInUser = useSelector((state) => state.auth.user);
	const {
		data: assignmentMarks,
		isSuccess: isAssignmentMarkQuerySuccess,
		isLoading: isAssignmentMarkQueryLoading,
		isError: isGetAssignmentMarkFetchError,
	} = useGetAssignmentMarksQuery() || {};
	const {
		data: quizMarks,
		isSuccess: isQuizGetQuerySuccess,
		isLoading: isQuizGetQueryLoading,
		isError: isQuizMarkFetchError,
	} = useGetQuizMarksQuery() || {};
	const {
		data: students,
		isSuccess: isGetUsersQuerySuccess,
		isLoading: isGetUsersQueryLoading,
		isError: isGetUsersFetchError,
	} = useGetStudentsQuery() || {};

	let studentMarks = [];
	let leaderboardContent = null;
	if (
		isAssignmentMarkQueryLoading ||
		isQuizGetQueryLoading ||
		isGetUsersQueryLoading
	) {
		leaderboardContent = <Loading />;
	} else if (
		isGetAssignmentMarkFetchError ||
		isQuizMarkFetchError ||
		isGetUsersFetchError
	) {
		leaderboardContent = (
			<div className="mx-auto max-w-7xl px-5 lg:px-0">
				<Error message="There was an error" />
			</div>
		);
	} else if (
		isAssignmentMarkQuerySuccess &&
		isQuizGetQuerySuccess &&
		isGetUsersQuerySuccess &&
		students?.length === 0
	) {
		leaderboardContent = (
			<div className="mx-auto max-w-7xl px-5 lg:px-0">
				<EmptyResult message="No leaderboard data found!" />
			</div>
		);
	} else if (
		isAssignmentMarkQuerySuccess &&
		isQuizGetQuerySuccess &&
		isGetUsersQuerySuccess
	) {
		studentMarks = students.map((user) => ({
			rank: 0,
			id: user.id,
			name: user.name,
			quizMark: 0,
			assignmentMark: 0,
			total: 0,
		}));

		studentMarks = studentMarks.map((studentMark) => {
			const assMarks =
				assignmentMarks.filter(
					(am) => am.student_id === studentMark.id
				) || [];
			const obtainedAssignmentMark = assMarks.reduce(
				(prev, curr) => prev + curr.mark,
				0
			);

			const qzMarks =
				quizMarks.filter((q) => q.student_id === studentMark.id) || [];
			const obtainedQuizMark = qzMarks.reduce(
				(prev, curr) => prev + curr.mark,
				0
			);

			studentMark.quizMark = obtainedQuizMark;
			studentMark.assignmentMark = obtainedAssignmentMark;
			studentMark.total = obtainedQuizMark + obtainedAssignmentMark;
			return studentMark;
		});

		studentMarks.sort((a, b) => b.total - a.total);

		// Prepare rank by mark
		let rankedStudentMarks = [];
		for (let index = 0; index < studentMarks.length; index++) {
			studentMarks[index].rank =
				index > 0 &&
				studentMarks[index].total === studentMarks[index - 1].total
					? studentMarks[index - 1].rank
					: index + 1;

			if (studentMarks[index].rank > 20) {
				break;
			}
			rankedStudentMarks.push(studentMarks[index]);
		}

		const myMark = rankedStudentMarks.find(
			(mark) => mark.id === loggedInUser.id
		);

		leaderboardContent = (
			<div className="mx-auto max-w-7xl px-5 lg:px-0">
				<MyPosition data={myMark} />
				<Top20Position
					data={rankedStudentMarks}
					loggedInUserId={loggedInUser.id}
				/>
			</div>
		);
	}

	return <section className="py-6 bg-primary">
		{leaderboardContent}
	</section>;
}
